<div class="main-cnt d-flex justify-content-center align-items-center vh-100">
  <div class="overlay-bg"></div>
  <div class="p-3 text-center p-2 m-2 text-cnt">
		<h1>{{ 'GENERIC.COMMON_PAGES.SERVICE_UNAVAILABLE_HEADER' | translate }}</h1>
    <p>{{ 'GENERIC.COMMON_PAGES.SERVICE_UNAVAILABLE_BODY' | translate }}</p>
  </div>
</div>
